<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    class="custom-font text-uppercase"
  >
    <q-card class="full-width pragma-black text-white">
      <q-form @submit.prevent="aprobar()">
        <q-card-section class="q-pa-none text-white">
          <q-toolbar
            class="bg-pragma"
          >
            <span class="text-bold">Aprobar Solicitud</span>
            <q-space></q-space>
            <q-btn
              icon="clear"
              flat
              @click="closeDialog()"
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-xs-12">
              <q-checkbox
                v-model="observar"
                label="¿Desea realizar alguna observación?"
                dark
              ></q-checkbox>
            </div>
            <div class="col-xs-12" v-if="observar">
              <q-input
                v-model="observacion"
                type="textarea"
                label="Describa sus observaciones"
                class="tu"
                autogrow
                dense
                outlined
                label-color="grey"
                dark
                :rules="[v => !!v || 'Requerido']"
              ></q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                label="Cancelar"
                color="negative"
                icon="clear"
                class="full-width"
                @click="closeDialog()"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                type="submit"
                label="Aprobar"
                color="positive"
                icon="check"
                class="full-width"
                :loading="loading"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'
// import util from '../../../plugins/util'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const $q = useQuasar()
    
    const dialog = ref(false)
    const observar = ref(false)
    const observacion = ref('')
    const solicitud_id = ref(null)
    const loading = ref(false)
    const type = ref('creada')

    // Métodos y funciones
    const aprobar = async () => {
      try {
        loading.value = true
        let platform
        if ($q.platform.is.platform === 'android') {
          platform = 'A'
        } else if ($q.platform.is.platform === 'iphone') {
          platform = 'I'
        } else {
          platform = 'W'
        }
        switch (type.value) {
          case 'creada':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-creada?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-creada?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'autorizada':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-autorizada?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-autorizada?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'aprobar':
            observar.value ? 
            await axios.get(`solicitud-aprobacion?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente2':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente2?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente2?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente3':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente3?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente3?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente4':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente4?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente4?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente5':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente5?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente5?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente6':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente6?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente6?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente7':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente7?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente7?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente8':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente8?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente8?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente9':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente9?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente9?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente10':
            observar.value ? 
            await axios.get(`solicitud-aprobacion-pendiente10?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) : 
            await axios.get(`solicitud-aprobacion-pendiente10?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente11':
            observar.value ?
            await axios.get(`solicitud-aprobacion-pendiente11?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) :
            await axios.get(`solicitud-aprobacion-pendiente11?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
          case 'pendiente12':
            observar.value ?
            await axios.get(`solicitud-aprobacion-pendiente12?id_sol=${solicitud_id.value}&obs=${observacion.value}&platform=${platform}`) :
            await axios.get(`solicitud-aprobacion-pendiente12?id_sol=${solicitud_id.value}&obs=SO&platform=${platform}`)
            break
        }
        /* if (observar.value) {
          await axios.get(`solicitud-aprobacion-creada/${solicitud_id.value}/${observacion.value}/${platform}`)
        } else {
          await axios.get(`solicitud-aprobacion-creada/${solicitud_id.value}/SO/${platform}`)
        } */
        $q.notify({
          message: 'Solicitud aprobada',
          color: 'positive'
        })

        // Reseteo de variables
        observacion.value = ''
        solicitud_id.value = null
        loading.value = false
        observar.value = false
        bus.emit('closeDialogEventoAutorizar')
        closeDialog()
      } catch (error) {
        loading.value = false
        return console.log(error)
      }
    }

    const closeDialog = () => {
      observar.value = false
      observacion.value = ''
      solicitud_id.value = null
      loading.value = false
      dialog.value = false
    }

    // Creación del componente
    bus.on('openDialogAprobarSolicitud', (data) => {
      solicitud_id.value = data.solicitud_id
      type.value = data.type
      dialog.value = true
    })

    // Retorno de variables al template
    return {
      dialog,
      observar,
      observacion,
      loading,
      closeDialog,
      aprobar
    }
  }
}
</script>

<style>

</style>